exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-description a {\n    text-decoration: none !important;\n    color: inherit;\n}\n", ""]);

// exports
